<template>
  <div class="c-content">
    <div class="title">
      <div class="span">默认运费</div>
      <div class="span">
        <el-input
          v-model="baseNumber1"
          :disabled="!isEdit"
          oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
        ></el-input>
      </div>
      <div class="span">千克</div>
      <div class="span">
        <el-input
          v-model="freight1"
          :disabled="!isEdit"
          oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
        >
        </el-input>
      </div>
      <div class="span">元</div>
      <div class="span">每增加</div>
      <div class="span">
        <el-input
          v-model="addNum1"
          :disabled="!isEdit"
          oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
        >
        </el-input>
      </div>
      <div class="span">千克</div>
      <div class="span">增加运费</div>
      <div class="span">
        <el-input
          v-model="addPrice1"
          :disabled="!isEdit"
          oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
        >
        </el-input>
      </div>
      <div class="span">元</div>
    </div>
    <div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="date" label="运送到" width="300px">
          <template slot-scope="scope">
            <span>{{ scope.row.address }}</span>
            <span
              style="margin-left: 10px; color: red"
              @click="add('edit', scope.row, scope.$index)"
              v-if="isEdit"
              >编辑</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="firstNum" label="首件数（千克）">
          <template slot-scope="scope">
            <el-input
              size="small"
              style="width: 100%"
              v-model="scope.row.firstNum"
              :disabled="!isEdit"
            >
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="freight" label="收费（元）">
          <template slot-scope="scope">
            <el-input
              size="small"
              style="width: 100%"
              v-model="scope.row.freight"
              :disabled="!isEdit"
            >
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="addNum" label="续件数（千克）">
          <template slot-scope="scope">
            <el-input
              size="small"
              style="width: 100%"
              v-model="scope.row.addNum"
              :disabled="!isEdit"
            >
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="addPrice" label="续费（元）">
          <template slot-scope="scope">
            <el-input
              size="small"
              style="width: 100%"
              v-model="scope.row.addPrice"
              :disabled="!isEdit"
            >
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="操作" v-if="isEdit">
          <template slot-scope="scope">
            <span style="color: red" @click="deleteArea(scope.$index)"
              >删除</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <div style="margin-top: 20px; text-align: center">
        <el-button style="color: #137dff" @click="add('add')" v-if="isEdit"
          >添加指定城市价格</el-button
        >
      </div>
    </div>
    <el-dialog
      title="选择地区"
      :visible.sync="isShow"
      width="40%"
      :append-to-body="true"
    >
      <template>
        <div
          style="display: flex"
          v-for="(item, index) in cityData"
          :key="index"
        >
          <div style="margin-top: 2px; margin-right: 4px">
            <el-checkbox
              v-model="item.checked"
              @change="handleCheckAllChange(index, item.checked)"
              >{{ item.label }}</el-checkbox
            >
          </div>
          <div>
            <el-tree
              ref="tree"
              :data="item.children"
              show-checkbox
              node-key="id"
              :default-expand-all="false"
              :expand-on-click-node="true"
              @check-change="checkChange(index)"
              :props="defaultPorps"
              :default-checked-keys="checkId"
            >
              <span class="custom-tree-node" slot-scope="{ node }">
                <span>{{ node.label }}</span
                ><i
                  v-show="node.level == 1"
                  class="el-icon-caret-bottom"
                  style="font-size: 20px; margin-left: 4px; margin-top: 2px"
                ></i>
              </span>
            </el-tree>
          </div>
        </div>

        <div style="margin: 15px 0"></div>
        <div style="text-align: center; margin-top: 20px">
          <el-button type="primary" @click="saveAddress">保存</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'number',
  props: {
    isEdit: {
      type: Boolean,
      default: true,
      // default: () => { totalNum: 0, price: 0,list: [] }
    },
    tableData: {
      type: Array,
      default: [],
      // default: () => { totalNum: 0, price: 0,list: [] }
    },
    freight: {
      type: Number,
      default: '',
      // default: () => { totalNum: 0, price: 0,list: [] }
    },
    baseNumber: {
      type: Number,
      default: '',
      // default: () => { totalNum: 0, price: 0,list: [] }
    },
    addNum: {
      type: Number,
      default: '',
      // default: () => { totalNum: 0, price: 0,list: [] }
    },
    addPrice: {
      type: Number,
      default: '',
      // default: () => { totalNum: 0, price: 0,list: [] }
    },
  },
  data () {
    return {
      freight1: '',
      baseNumber1: '',
      addNum1: '',
      addPrice1: '',
      cityData: [
        {
          id: 1,
          label: '华北',
          checked: false,
          children: [
            {
              id: 4,
              label: '北京市'
            },
            {
              id: 5,
              label: '天津市'
            },
            {
              id: 6,
              label: '河北省',
              children: [{
                id: 61,
                label: '廊坊市'
              }, {
                id: 62,
                label: '廊坊市'
              }, {
                id: 63,
                label: '廊坊市'
              }, {
                id: 64,
                label: '廊坊市'
              }]
            },
            {
              id: 7,
              label: '山西省',
              children: []
            },
            {
              id: 8,
              label: '内蒙古自治区',
              children: [{
                id: 81,
                label: '廊坊市'
              }]
            }
          ]
        },
        {
          id: 2,
          label: '华中',
          checked: false,
          children: [
            {
              id: 22,
              label: '北京市'
            },
            {
              id: 23,
              label: '天津市'
            },
            {
              id: 24,
              label: '河北省',
              children: [{
                id: 245,
                label: '廊坊市'
              }, {
                id: 246,
                label: '廊坊市'
              }, {
                id: 247,
                label: '廊坊市'
              }, {
                id: 248,
                label: '廊坊市'
              }]
            }
          ]
        }
      ],
      selectData: [],
      checkId: ['560'],
      defaultPorps: {
        children: 'children',
        label: 'label'
      },
      number: '',
      radio: '',
      isShow: false,
      cityOptions: ['上海', '北京', '广州', '深圳'],
      checkAll: false,
      checkedCities: ['上海', '北京'],
      cities: ['上海', '北京', '广州', '深圳'],
      isIndeterminate: true,
      // tableData: [],
      addressData: [],
      type: 'add',
      addressDataParent: [],
      editIndex: null
    }
  },
  watch: {
    isShow: {
      handler (newVal, oldVal) {
        // if (!newVal) {
        //   this.tableData.forEach(item => {
        //     Object.assign(item, { addressData: JSON.stringify(item.addressData) })
        //   })
        // }
      }
    },
    tableData: {
      handler (newVal, oldVal) {
        console.log(newVal)
        let data = {
          freight: this.freight1,
          baseNumber: this.baseNumber1,
          addNum: this.addNum1,
          addPrice: this.addPrice1,
          tableData: newVal
        }
        this.tableData = newVal
        // this.tableData.forEach(item => {
        //   if (typeof (item.addressData) == 'string') {
        //     if (typeof (JSON.parse(item.addressData)) == 'string') {
        //       Object.assign(item, { addressData: JSON.parse(JSON.parse(item.addressData)) })
        //     } else {
        //       Object.assign(item, { addressData: JSON.parse(item.addressData) })
        //     }

        //   } else {
        //     Object.assign(item, { addressData: item.addressData })
        //   }
        // })
        // this.areas()
        this.$emit('change', data)
      },
      deep: true,
    },
    freight1: {
      handler (newVal, oldVal) {
        console.log(newVal)
        let data = {
          freight: newVal,
          baseNumber: this.baseNumber1,
          addNum: this.addNum1,
          addPrice: this.addPrice1,
          tableData: this.tableData
        }
        this.$emit('change', data)
      },
      deep: true,
    },
    baseNumber1: {
      handler (newVal, oldVal) {
        console.log(newVal)
        let data = {
          freight: this.freight1,
          baseNumber: newVal,
          addNum: this.addNum1,
          addPrice: this.addPrice1,
          tableData: this.tableData
        }
        this.$emit('change', data)
      },
      deep: true,
    },
    addNum1: {
      handler (newVal, oldVal) {
        console.log(newVal)
        let data = {
          freight: this.freight1,
          baseNumber: this.baseNumber1,
          addNum: newVal,
          addPrice: this.addPrice1,
          tableData: this.tableData
        }
        this.$emit('change', data)
      },
      deep: true,
    },
    addPrice1: {
      handler (newVal, oldVal) {
        console.log(newVal)
        let data = {
          freight: this.freight1,
          baseNumber: this.baseNumber1,
          addNum: this.addNum1,
          addPrice: newVal,
          tableData: this.tableData
        }
        this.$emit('change', data)
      },
      deep: true,
    }
  },
  created () {
    this.getRegionList()
    this.freight1 = this.freight
    this.addNum1 = this.addNum
    this.baseNumber1 = this.baseNumber
    this.addPrice1 = this.addPrice
    // this.tableData.forEach(item => {
    //   if (typeof (item.addressData) == 'string') {
    //     if (typeof (JSON.parse(item.addressData)) == 'string') {
    //       Object.assign(item, { addressData: JSON.parse(JSON.parse(item.addressData)) })
    //     } else {
    //       Object.assign(item, { addressData: JSON.parse(item.addressData) })
    //     }

    //   } else {
    //     Object.assign(item, { addressData: item.addressData })
    //   }
    // })
  },
  mounted () {
    console.log(this.freight)
    this.freight1 = this.freight
    this.addNum1 = this.addNum
    this.baseNumber1 = this.baseNumber
    this.addPrice1 = this.addPrice
  },
  methods: {
    // //地区处理
    // areas (val) {
    //   this.tableData.forEach(item => {
    //     Object.assign(item, { address: item.betterAddress })
    //     Object.assign(item, { addressData: JSON.parse(item.regionJson) })
    //   })
    // },
    saveAddress () {
      console.log(this.addressDataParent, this.addressData)
      let address = []//显示数组
      let tempary = []
      tempary = JSON.parse(JSON.stringify(this.addressData))
      for (let i = 0; i < tempary.length; i++) {
        this.addressDataParent.forEach(item => {
          item.children.forEach(itm => {
            if (tempary[i].id == itm.id) {
              console.log('delete')
              tempary.splice(i, 1)
            }
          })

        })
      }
      console.log(tempary, this.addressData)
      address = this.addressDataParent.concat(tempary)
      let str = ''
      console.log(address)
      Array.from(new Set(address)).forEach(item => {
        if (str == '') {
          str = str + item.label
        } else {
          str = str + '、' + item.label
        }

      })
      let obj = {
        address: str,
        addressData: this.addressData,
        firstNum: 0,
        freight: 0,
        addNum: 0,
        addPrice: 0,
        regionJson: JSON.stringify(this.addressData)
      }
      if (this.type == 'add') {
        this.tableData.push(obj)
        // this.tableData.forEach(item => {
        //   Object.assign(item, { addressData: JSON.stringify(item.addressData) })
        // })
      } else {
        this.tableData[this.editIndex].address = str
        this.tableData[this.editIndex].addressData = this.addressData
        // this.tableData.forEach(item => {
        //   Object.assign(item, { addressData: JSON.stringify(item.addressData) })
        // })
        this.tableData[this.editIndex].regionJson = JSON.stringify(this.addressData)
      }
      this.isShow = false
    },
    getRegionList () {
      this.$api.goodsRegionList({}).then((res) => {
        console.log(res.data)

        res.data.forEach(item => {
          Object.assign(item, { checked: false })
          Object.assign(item, { label: item.regionName })
          Object.assign(item, { children: item.provinceList })
          item.children.forEach(itm => {
            Object.assign(itm, { checked: false })
            Object.assign(itm, { label: itm.provinceName })
            Object.assign(itm, { children: itm.cityList })
            itm.children.forEach(it => {
              Object.assign(it, { checked: false })
              Object.assign(it, { label: it.cityName })
            })
          })
        })
        this.cityData = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    checkChange (index) {
      let checked_count = 0 // 被勾选上的一级节点个数
      let disabled_count = 0 // 置灰的一级节点个数
      let indeterminate_flag = false // 有没有一级节点处于半选状态
      // 深度遍历所有一级节点
      var numArray = []
      const stack = [...this.cityData[index].children]; let node
      while (node = stack.shift()) {
        numArray.push(node.id)
        if (this.$refs.tree[index].getNode(node).disabled === true) {
          disabled_count += 1// 如果有置灰的节点，置灰变量加1
        }
        if (this.$refs.tree[index].getNode(node).checked === true) {
          checked_count += 1// 如果有勾选的节点，勾选变量加1
        }
        if (this.$refs.tree[index].getNode(node).indeterminate === true) {
          indeterminate_flag = true// 如果有半选的节点，半选变量设为true
        }
        // 如果有子元素的话进行压栈操作
        if (node.children) stack.unshift(...node.children)
      }
      if (checked_count == 0) {
        this.isIndeterminate = false
        this.cityData[index].checked = false // 如果勾选的一级节点数为0，则设置全选按钮样式不为半选样式，全选的值为false
        if (indeterminate_flag == true) { // 如果下面有半选的，设置全选按钮的样式为半选样式
          this.isIndeterminate = true
          this.cityData[index].checked = false
        }
      } else if ((checked_count + disabled_count) == numArray.length) { // 如果树上勾上的和置灰的加起来等于tree上data的长度，设置全选按钮样式不为半选样式，全选值为true
        this.isIndeterminate = false
        this.cityData[index].checked = true
      } else { // 上面条件不满足，则说明没有全部勾上，设置样式为半选，全选值为false
        this.isIndeterminate = true
        this.cityData[index].checked = false
      }
      this.getNodesData(index)
      return
    },
    //获取所选节点数据
    getNodesData (index) {
      this.addressData = []
      this.addressDataParent = []
      for (let i = 0; i < this.cityData.length; i++) {
        console.log(this.$refs.tree[i].getCheckedNodes(false, true))
        console.log(this.$refs.tree[i].getCheckedNodes(true, true))

        this.$refs.tree[i].getCheckedNodes().forEach(item => {
          // this.addressData.push(item)
          if (!item.children) {
            this.addressData.push(item)
          } else {
            this.addressDataParent.push(item)
            // this.cityData[i].children.forEach(itm => {
            //   itm.checked = true
            // })
          }
        })
      }
      console.log(this.addressData)
    },
    handleCheckAllChange (index, val) {
      // console.log(index, this.$refs.tree[index], this.selectData)
      this.isIndeterminate = false
      if (this.cityData[index].checked === true) {
        // 深度遍历
        const stack = [...this.cityData[index].children]
        let node
        while (node = stack.shift()) {
          console.log(node.id)
          this.$refs.tree[index].setChecked(node.id, true, true)
          // 如果有子元素的话进行压栈操作
          if (node.children) stack.unshift(...node.children)
        }
        this.getNodesData(index)
      } else {
        this.$refs.tree[index].setCheckedKeys([])
      }
      this.$forceUpdate()
    },
    handleCheckedCitiesChange (value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.cities.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length
    },
    addAttr (data, id, val) {
      console.log(data, id)
      data.forEach(item => {
        item.children.forEach(itm => {
          itm.children.forEach(it => {
            if (it.id == id) {
              this.$set(it, 'disabled', val);
            }
          })
          let a = false
          a = itm.children.every(p => {
            return p.disabled == true
          })
          if (a) {
            this.$set(itm, 'disabled', true);
          } else {
            this.$set(itm, 'disabled', false);
          }
          let b = false
          b = item.children.every(p => {
            return p.disabled == true
          })
          if (b) {
            this.$set(item, 'disabled', true);
          } else {
            this.$set(item, 'disabled', false);
          }
        })
      });
    },
    add (type, row, index) {
      this.tableData.forEach(item => {
        if (typeof (item.addressData) == 'string') {
          if (typeof (JSON.parse(item.addressData)) == 'string') {
            Object.assign(item, { addressData: JSON.parse(JSON.parse(item.addressData)) })
          } else {
            Object.assign(item, { addressData: JSON.parse(item.addressData) })
          }

        } else {
          Object.assign(item, { addressData: item.addressData })
        }
      })
      this.type = type
      this.editIndex = index
      if (type == 'edit') {
        this.isShow = true
        this.$nextTick(() => {
          console.log(this.tableData)
          for (let i = 0; i < this.cityData.length; i++) {
            this.$refs.tree[i].setCheckedKeys([])
          }
          // this.tableData.forEach(item => {
          //   Object.assign(item, { addressData: JSON.parse(item.addressData) })
          // })
          this.tableData.forEach(item => {
            item.addressData.forEach(itm => {
              this.addAttr(this.cityData, itm.id, true)
            })
          })
          this.checkId = []
          this.tableData[index].addressData.forEach(item => {
            this.checkId.push(item.id)
            this.addAttr(this.cityData, item.id, false)
          })

        })
      } else {
        // this.addressData = []
        this.isShow = true
        this.$nextTick(() => {
          for (let i = 0; i < this.cityData.length; i++) {
            this.$refs.tree[i].setCheckedKeys([])
          }
          console.log(this.addressData)
          // this.tableData.forEach(item => {
          //   Object.assign(item, { addressData: JSON.parse(item.addressData) })
          // })
          this.tableData.forEach(item => {
            item.addressData.forEach(itm => {
              this.addAttr(this.cityData, itm.id, true)
            })

          })

        })

      }

    },
    deleteArea (index) {
      const msg = `此操作将删除该地区运费, 是否继续?`
      this.$confirm(msg, '提示', {
        title: '删除',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.tableData.splice(index, 1)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
      // this.tableData.splice(index, 1)
    }
  }
}
</script>
<style>
.el-icon-caret-right:before {
  content: " ";
}
</style>
<style scoped lang="scss">
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
// el-tree 三级菜单横向布局 样式
.el-tree {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  ::v-deep .el-tree-node__children {
    display: flex;
    flex-direction: column;
    .el-tree-node__children {
      display: flex;
      flex-direction: column;
      .el-tree__children {
        display: flex;
        flex-direction: column;
      }
      color: #909399;
    }
  }
}
.c-content {
  // margin-left: 18px;
  .title {
    display: flex;
    background-color: #f1f6ff;
    height: 50px;
    line-height: 36px;
    padding-top: 8px;
  }
  .span {
    margin-left: 10px;
  }
}
</style>
